import Cookies from "js-cookie";
import config from "@/config";
import { forEach, hasOneOf } from "./tools";

const { cookieExpires, TOKEN_NAME, cookieDoMain } = config;

export const setToken = token => {
  Cookies.set(TOKEN_NAME, token, { expires: cookieExpires, domain: cookieDoMain });
};

export const getToken = () => {
  const token = Cookies.get(TOKEN_NAME);
  if (token) {
    return token;
  } else {
    return false;
  }
};

export const removeToken = () => {
  Cookies.remove(TOKEN_NAME, { domain: cookieDoMain });
};
export const hasChild = item => {
  return item.children && item.children.length !== 0;
};
export const isShowSideMenu = (item, access) => {
  if (item.meta && item.meta.permissionId) {
    return !!hasOneOf(access, [item.meta.permissionId]);
  } else {
    return true;
  }
};
/*
 * @param { array }list 路由列表
 * @param accessList { array } 权限列表
 * @return { array }
 */
export const getSideMenuByRouter = (list, access = ["admin"]) => {
  let res = [];
  forEach(list, item => {
    if (item.meta && item.meta.showInSideMenu) {
      let obj = {
        name: item.name,
        meta: item.meta,
        path: item.path
      };
      // console.log(isShowSideMenu(item, access));
      if (isShowSideMenu(item, access)) {
        res.push(obj);
      }
    }
  });
  // console.log(res);
  return res;
};

export const getBreadCrumbList = route => {
  let routeMetched = route.matched;
  let res = routeMetched
    .filter(item => {
      return item.meta === undefined || !item.meta.hideInBread;
    })
    .map(item => {
      let meta = { ...item.meta };
      let obj = {
        icon: (item.meta && item.meta.icon) || "",
        name: item.name,
        meta: meta
      };
      return obj;
    });
  return res;
};
/*
 * @params access 权限数组 [ "4", "5"]
 * @params route 路由列表
 * @desc 判断有没有权限访问路由
 * @return true 有， false 没有
 * */
const hasAccess = (access, route) => {
  if (route.meta && route.meta.permissionId) {
    return hasOneOf(access, [route.meta.permissionId]);
  } else {
    return true;
  }
};
/*
 *权限验证
 *@params name 要跳转的路由名称
 *@params access 用户权限列表
 *@params routes 路由列表
 * */
export const canTurnTo = (to, access) => {
  const routePermissionJudge = list => {
    return list.some(item => {
      // !hasAccess 取反终止 some循环
      return !hasAccess(access, item);
    });
  };
  //some 里取反，这里再次取反，是返回值正常
  return !routePermissionJudge(to.matched);
};

/*
 * 工单样式 生成工单样式的json
 *@params componentData 组件生成的数据
 *@params index 排序下标 从0开始
 * */
export const createComponentJson = (componentData, index) => {
  index = index + 1;
  const strategy = {
    tempRadio(data, sort) {
      let result = {
        type: 0,
        sort,
        is_checked: data.required,
        title: data.title,
        option: []
      };
      data.items.forEach(item => {
        result.option.push({
          key: item.key,
          value: item.value,
          is_default: Number(item.default),
          is_warning: Number(item.abnormal)
        });
      });
      return result;
    }, //
    tempMultiSelect(data, sort) {
      let result = {
        type: 1,
        sort,
        is_checked: data.required,
        title: data.title,
        option: []
      };
      data.items.forEach(item => {
        result.option.push({
          key: item.key,
          value: item.value,
          is_default: Number(item.default),
          is_warning: Number(item.abnormal)
        });
      });
      return result;
    }, //
    tempNumber(data, sort) {
      let result = {
        type: 2,
        sort,
        is_checked: data.required,
        title: data.title,
        unit: data.unit,
        digit_num: data.decimal,
        min_value: data.min,
        max_value: data.max
      };
      return result;
    }, //
    tempMultilineText(data, sort) {
      let result = {
        type: 5,
        sort,
        is_checked: data.required,
        title: data.title,
        word_num: data.cont,
        default_content: data.content
      };
      return result;
    }, //
    tempPicture(data, sort) {
      let result = {
        type: 6,
        sort,
        is_checked: data.required,
        title: data.title,
        photo_num: data.cont,
        pic_type: Number(data.isForce)
      };
      return result;
    }, //
    tempSignature(data, sort) {
      let result = {
        type: 7,
        sort,
        is_checked: data.required,
        title: data.title
      };
      return result;
    }, //
    tempReadOnly(data, sort) {
      return {
        type: 9,
        sort,
        title: data.title,
        content: data.content
      };
    }
  };
  return (
    strategy[componentData.componentName] &&
    strategy[componentData.componentName](componentData.data, index)
  );
};

/*
 * 工单样式 根据接口返回 生成工单样式的组件
 *@params componentData 组件生成的数据
 *@params index 排序下标 从0开始
 * */
export const createOrderTempLocalData = (componentAjaxData) => {
  const strategy = {
    type0(data) {
      let result = {
        componentName: "tempRadio",
        data: {
          required: Number(data.is_checked),
          title: data.title,
          items: []
        }
      };
      data.option.forEach((item, index) => {
        result.data.items.push({
          key: Number(item.key) || index + 1,
          value: item.value,
          default: Boolean(Number(item.is_default)),
          abnormal: Boolean(Number(item.is_warning))
        });
      });
      return result;
    },
    type1(data) {
      let result = {
        componentName: "tempMultiSelect",
        data: {
          required: Number(data.is_checked),
          title: data.title,
          items: []
        }
      };
      data.option.forEach((item, index) => {
        result.data.items.push({
          key: Number(item.key) || index + 1,
          value: item.value,
          default: Boolean(Number(item.is_default)),
          abnormal: Boolean(Number(item.is_warning))
        });
      });
      return result;
    },
    type2(data) {
      return {
        componentName: "tempNumber",
        data: {
          required: Number(data.is_checked),
          title: data.title,
          unit: data.unit,
          decimal: Number(data.digit_num),
          min: Number(data.min_value),
          max: Number(data.max_value)
        }
      };
    },
    type5(data) {
      return {
        componentName: "tempMultilineText",
        data: {
          required: Number(data.is_checked),
          title: data.title,
          cont: Number(data.word_num),
          content: data.default_content
        }
      };
    },
    type6(data) {
      return {
        componentName: "tempPicture",
        data: {
          required: Number(data.is_checked),
          title: data.title,
          cont: Number(data.photo_num),
          isForce: Boolean(Number(data.pic_type))
        }
      };
    },
    type7(data) {
      return {
        componentName: "tempSignature",
        data: {
          required: Number(data.is_checked),
          title: data.title
        }
      };
    },
    type9(data) {
      return {
        componentName: "tempReadOnly",
        data: {
          title: data.title,
          content: data.content
        }
      };
    }
  };
  return (
    strategy[`type${componentAjaxData.type}`] &&
    strategy[`type${componentAjaxData.type}`](componentAjaxData)
  );
}

/**
 * 工单样式 视图，只看不编辑
 *
 */

export const createOrderViewTempLocalData = (componentAjaxData) => {
    const strategy = {
      strategy0(data) {
        console.log(data);
        let result = {
          name: data.type_name,
          type: "tempRadioView",
          title: data.title,
          required: data.is_checked,
          sort: data.sort,
          options: []
        };
        data.option.forEach(item => {
          result.options.push({
            key: item.key,
            value: item.value,
            isWarning: item.is_warning
          });
          if (item.is_default == 1) {
            result.value = item.key;
          }
        });
        return result;
      },
      strategy1(data) {
        let result = {
          name: data.type_name,
          type: "tempMultiSelectView",
          title: data.title,
          required: data.is_checked,
          sort: data.sort,
          options: [],
          value: []
        };
        data.option.forEach(item => {
          result.options.push({
            key: item.key,
            value: item.value,
            isWarning: item.is_warning
          });
          if (item.is_default == 1) {
            result.value.push(item.key);
          }
        });
        return result;
      },
      strategy2(data) {
        let result = {
          name: data.type_name,
          type: "tempNumberView",
          title: data.title,
          value: data.result,
          required: data.is_checked,
          sort: data.sort,
          maxValue: data.max_value,
          minValue: data.min_value,
          unit: data.unit
        };
        return result;
      },
      strategy3(data) {
        return {
          name: data.type_name,
          type: "tempDeviceParamsView",
          title: data.title,
          required: data.is_checked,
          sort: data.sort,
          content: data.content
        };
      },
      strategy5(data) {
        return {
          name: data.type_name,
          type: "tempTextareaView",
          title: data.title,
          required: data.is_checked,
          sort: data.sort,
          content: data.default_content
        };
      },
      strategy6(data) {
        return {
          name: data.type_name,
          type: "tempPicView",
          title: data.title,
          required: data.is_checked,
          sort: data.sort
        };
      },
      strategy7(data) {
        return {
          name: data.type_name,
          type: "tempSignatureView",
          title: data.title,
          required: data.is_checked,
          sort: data.sort
        };
      }
    };
      return (
        strategy[`strategy${componentAjaxData.type}`] && strategy[`strategy${componentAjaxData.type}`](componentAjaxData)
      );
}
